import React from 'react';

import type * as ReportTypes from '../../state/reports/types';
import type * as PanelSettingsTypes from '../../state/views/panelSettings/types';
import {type LoadableView} from '../../state/views/types';

interface WBSlateReduxBridgeContextValue {
  entityName: string;
  projectName: string;
  viewId: string;
  viewRef: ReportTypes.ReportViewRef | null;
  view: LoadableView | null;
  panelSettingsRef: PanelSettingsTypes.Ref | null;
}

export const WBSlateReduxBridgeContext =
  React.createContext<WBSlateReduxBridgeContextValue>({} as any);

export type WBSlateReduxBridgeDebouncedProps = {
  projectName: string;
  entityName: string;
  viewId: string;
  viewRef: ReportTypes.ReportViewRef;
  view: LoadableView;
  readOnly: boolean;
};
